import React, { ReactNode } from "react"
import { useAppSelector } from "appRedux/hooks"
import { useGetActiveSubscriptionQuery } from "appRedux/slices/premiumApiSlice"
import { useServiceWorker } from "hooks/useServiceWorker"
import SubscriptionExpiringReminder from "components/molecules/SubscriptionExpiringReminder"
import UpdateAvailableReminder from "components/molecules/UpdateAvailableReminder"

export default function AppRootWrapper({ children }: { children: ReactNode }) {
  const isPremium = useAppSelector((state) => state.user.profile?.isPremium)

  useServiceWorker()

  useGetActiveSubscriptionQuery(undefined, {
    skip: !isPremium
  })

  return (
    <>
      {isPremium && <SubscriptionExpiringReminder/>}
      <UpdateAvailableReminder/>
      {children}
    </>
  )
}
